namespace GeniuzPOS.Lookups {
    export namespace VwPluLookupSetItemService {
        export const baseUrl = 'Lookups/VwPluLookupSetItem';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<VwPluLookupSetItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<VwPluLookupSetItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "Lookups/VwPluLookupSetItem/Retrieve",
            List = "Lookups/VwPluLookupSetItem/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>VwPluLookupSetItemService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
